import { GameVars } from "../../GameVars";
import { BoardState } from "./BoardState";
import { BoardContainer } from "./BoardContainer";
import { GameConstants } from "../../GameConstants";
import { GameManager } from "../../GameManager";

export class BoardManager {

    private static game: Phaser.Game;
    private static gameStarted: boolean;

    public static init(game: Phaser.Game): void {

        BoardManager.game = game;
        BoardManager.gameStarted = false;

        GameVars.time = 0;
        GameVars.matchOver = false;
        GameVars.flaggedCells = 0;
        GameVars.paused = false;

        switch (GameVars.difficulty) {

            case GameConstants.DIFFICULTY_EASY:
                GameVars.mines = 20;
                GameVars.boardSize = GameConstants.BOARD_SIZE_BEGINNER;
                break;
            case GameConstants.DIFFICULTY_MEDIUM:
                GameVars.mines = 40;
                GameVars.boardSize = GameConstants.BOARD_SIZE_INTERMEDIATE;
                break;
            case GameConstants.DIFFICULTY_HARD:
                GameVars.mines = 80;
                GameVars.boardSize = GameConstants.BOARD_SIZE_EXPERT;
                break;
            default:
                break;
        }
    }

    public static onSecondPassed(): void {

        if (GameVars.paused || GameVars.matchOver) {
            return;
        }

        GameVars.time++;

        BoardState.currentInstance.hud.updateTimer();
    }

    public static onCellUp(p: { r: number, c: number }, deltaTime: number, rightMouse: boolean): void {

        if (!BoardManager.gameStarted) {
            BoardManager.start(p);
        }

        if (deltaTime > 500 || rightMouse) {

            GameVars.board.cycleCellFlag(p.c, p.r);
            GameVars.grid = GameVars.board.grid();

            // HACEMOS ESTO PORQUE ESTA LIBRERIA TIENE 3 ESTADOS PARA EL FLAG EN LUGAR DE 2
            if (GameVars.grid[p.r][p.c].flag === 2) {
                GameVars.board.cycleCellFlag(p.c, p.r);
                GameVars.grid = GameVars.board.grid();
            }

            if (GameVars.grid[p.r][p.c].flag === 1) {

                BoardContainer.currentInstance.flagCell(p);
                GameVars.flaggedCells ++;

                if (GameVars.flaggedCells === GameVars.mines) {

                    const state = GameVars.board.state();

                    if (state === GameConstants.BOARD_STATE_LOST || state === GameConstants.BOARD_STATE_WON) {
                        BoardManager.matchOver(state === GameConstants.BOARD_STATE_WON, p);
                    }
                }

            } else {

                BoardContainer.currentInstance.unFlagCell(p);
                GameVars.flaggedCells --;
            }

            BoardState.currentInstance.hud.updateMines();

        } else {

            BoardManager.openCell(p);
        }
    }

    public static pauseGame(): void {

        GameVars.paused = true;

        BoardState.currentInstance.showPauseLayer();
    }

    public static resumeGame(): void {

        GameVars.paused = false;

        BoardState.currentInstance.hidePauseLayer();
    }

    public static checkSurroundingCells(p: { r: number, c: number }): void {

        const sorroundingCellsIndexes = GameVars.getSurroundingCells(p);

        BoardContainer.currentInstance.checkSurroundingCells(sorroundingCellsIndexes);
    }

    public static uncheckSurroundingCells(p: { r: number, c: number }, dt: number): void {
        
        const sourroundingCellsIndexes = GameVars.getSurroundingCells(p);

        if (dt < 250) {
            // mirar si las celdas con bandera alrededor coinciden con el numero en cuestion
            const n = GameVars.grid[p.r][p.c].numAdjacentMines;
            let flaggedCellsAround: {r: number, c: number} [] = [];

            for (let i = 0; i < sourroundingCellsIndexes.length; i ++) {
                const r = sourroundingCellsIndexes[i].r;
                const c = sourroundingCellsIndexes[i].c;

                if (GameVars.grid[r][c].flag === 1) {
                    flaggedCellsAround.push({r: r, c: c});
                }
            }
            
            if (flaggedCellsAround.length === n) {

                for (let j = 0; j < sourroundingCellsIndexes.length; j++) {

                    const r = sourroundingCellsIndexes[j].r;
                    const c = sourroundingCellsIndexes[j].c;

                    if (GameVars.grid[r][c].state === GameConstants.BOARD_STATE_PRISTINE && !GameVars.matchOver) {
                        BoardManager.openCell({r: r, c: c});
                    }
                }

            } else {

                BoardContainer.currentInstance.uncheckSurroundingCells(sourroundingCellsIndexes);
            }

        } else {

            BoardContainer.currentInstance.uncheckSurroundingCells(sourroundingCellsIndexes);  
        }
    }

    private static start(p: { r: number, c: number }): void {

        BoardManager.gameStarted = true;

        GameVars.paused = false;

        let mineArray = GameVars.minesweeper.generateMineArray({
            rows: GameVars.boardSize.r,
            cols: GameVars.boardSize.c,
            mines: GameVars.mines
        });

        // para asegurarnos de que el primer click nunca se hace sobre una mina
        while (mineArray[p.r][p.c] === 1) {
            mineArray = GameVars.minesweeper.generateMineArray({
                rows: GameVars.boardSize.r,
                cols: GameVars.boardSize.c,
                mines: GameVars.mines
            });
        }

        GameVars.board = new GameVars.minesweeper.Board(mineArray);
        GameVars.grid = GameVars.board.grid();

        BoardContainer.currentInstance.start();

        BoardManager.game.time.events.loop(Phaser.Timer.SECOND, BoardManager.onSecondPassed, BoardManager);
    }

    private static matchOver(won: boolean, p: {r: number, c: number}): void {

        GameVars.matchOver = true;

        BoardContainer.currentInstance.revealMinedCells(p);
        BoardContainer.currentInstance.hideFlags();

        if (won) {
            GameManager.matchOver();
        }

        BoardState.currentInstance.showMatchOverLayer(won);
    }

    private static openCell(p: {r: number, c: number}): void {

        GameVars.board.openCell(p.c, p.r);

        GameVars.grid = GameVars.board.grid();

        BoardContainer.currentInstance.revealOpenedCells();

        let state = GameVars.board.state();

        if (state === GameConstants.BOARD_STATE_LOST) {
            BoardManager.matchOver(false, p);
        } else {
            // MIRAR EL NUMERO DE CELDAS QUE QUEDAN SIN ABRIR
            // con state 0
            let unopenedCells = 0;
            for (let r = 0; r < GameVars.boardSize.r; r ++) {
                for (let c = 0; c < GameVars.boardSize.c; c ++) {
                    if (GameVars.grid[r][c].state === 0) {
                        unopenedCells ++;
                    }
                }
            }

            if (unopenedCells === GameVars.mines) {
                state = GameConstants.BOARD_STATE_WON;
            }

            if (state === GameConstants.BOARD_STATE_LOST || state === GameConstants.BOARD_STATE_WON) {
                BoardManager.matchOver(state === GameConstants.BOARD_STATE_WON, p);
            }
        }
    }
}
